import React, { useState } from 'react';

type RelationInterface = {
    registeringFor: string
    relation: string
    relationId: string
    customRelation: string
    UserId: string | null
    name: string
    gender: string
    email: string | null
    mobile: string | null
};
type UserDetailsInterface = {
    Id: string;
    Name: string;
    Email: string;
    Mobile: string;
    Gender: number | null;
    Address: string;
    RoleType: string;
};

type RelationProps = {
    relationDetails: RelationInterface;
    setRelationDetails: React.Dispatch<React.SetStateAction<RelationInterface>>;
    userDetails: UserDetailsInterface;
    setUserDetails: React.Dispatch<React.SetStateAction<UserDetailsInterface>>;
    userRelationData: any[];
    fetchedRelationData: any[];
    isDarkMode: boolean;
};

const Relation: React.FC<RelationProps> = ({ relationDetails, setRelationDetails, userDetails, setUserDetails, userRelationData, fetchedRelationData, isDarkMode }) => {

    const [relationOptions, setRelationOptions] = useState<string[]>(["Father", "Mother", "Brother", "Sister", "Husband", "Wife", "Son", "Daughter", "Grandfather", "Grandmother", "Cousin", "Friend", "other"]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setRelationDetails((prev) => ({ ...prev, [name]: value }));

        if (name === "registeringFor" && value !== "Self" && value !== "other") {
            const selectedUser = userRelationData.find(user => user.id === value);
            const selectedrelation = fetchedRelationData.find(relation => relation.relationUserData.id === value);

            if (selectedUser && selectedrelation) {
                if (relationOptions.includes(selectedrelation.relationType)) {
                    setRelationDetails(prev => ({
                        ...prev,
                        relation: selectedrelation.relationType,
                        relationId: selectedrelation.id,
                        UserId: selectedUser.id,
                        name: selectedUser.name,
                        email: selectedUser.email,
                        mobile: selectedUser.mobile,
                        gender: selectedUser.gender,
                        customRelation: ""
                    }));
                } else {
                    setRelationDetails(prev => ({
                        ...prev,
                        relation: "other",
                        relationId: selectedrelation.id,
                        UserId: selectedUser.id,
                        name: selectedUser.name,
                        email: selectedUser.email,
                        mobile: selectedUser.mobile,
                        gender: selectedUser.gender,
                        customRelation: selectedrelation.relationType
                    }));
                }
            }
        }
    };
    const handleUserDetailsChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setUserDetails(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return (
        <div className="flex flex-col space-y-4">
            <div className="flex flex-col space-y-2 w-full">
                <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>
                    Registering For <span className="text-red-500">*</span>
                </label>
                <select
                    id="RegisteringFor"
                    value={relationDetails.registeringFor}
                    name="registeringFor"
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                >
                    <option value="">Select</option>
                    <option value="Self"> Self </option>
                    {userRelationData.map((user, index) => (
                        <option value={user.id}>{user.name}</option>
                    ))}
                    <option value="other"> Others </option>
                </select>
            </div>

            {relationDetails.registeringFor === "Self" && (
                <>
                    <div className="flex flex-col space-y-4 w-full">
                        <div className="flex flex-col space-y-2 w-full">
                            <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>Name <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                id="name"
                                name="Name"
                                placeholder="Enter your Full Name"
                                value={userDetails.Name}
                                onChange={handleUserDetailsChange}
                                required
                            />
                        </div>

                        <div className="flex flex-col space-y-2 w-full">
                            <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>Email <span className="text-red-500">*</span></label>
                            <input
                                type="email"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                id="email"
                                placeholder="Enter your Email"
                                value={userDetails.Email}
                                onChange={handleUserDetailsChange}
                                required
                            />
                        </div>

                        <div className="flex flex-col space-y-2 w-full">
                            <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>Mobile <span className="text-red-500">*</span></label>
                            <input
                                type="text"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                id="mobile"
                                placeholder="Enter your Mobile Number"
                                value={userDetails.Mobile}
                                name="Mobile"
                                onChange={handleUserDetailsChange}
                                required
                            />
                        </div>

                        <div className="flex flex-col space-y-2 w-full">
                            <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>Gender <span className="text-red-500">*</span></label>
                            <select
                                id="gender"
                                value={userDetails.Gender}
                                name="Gender"
                                onChange={handleUserDetailsChange}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            >
                                <option value="">Select Gender</option>
                                <option value={1}>Male</option>
                                <option value={2}>Female</option>
                            </select>
                        </div>
                    </div>
                </>
            )}

            {relationDetails.registeringFor !== "Self" && (
                <>
                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>
                            Relation <span className="text-red-500">*</span>
                        </label>
                        <select
                            id="Relation"
                            name="relation"
                            value={relationDetails.relation}
                            onChange={handleChange}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        >
                            <option value="">Select</option>
                            {relationOptions.map((relation, index) => (
                                <option key={index} value={relation}>{relation}</option>
                            ))}
                        </select>
                    </div>
                    {relationDetails.relation === "other" && (
                        <div className="flex flex-col space-y-2 w-full">
                            <input
                                type="name"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                name="customRelation"
                                placeholder="Enter Relation"
                                value={relationDetails.customRelation}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    )}

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>
                            Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            id="name"
                            name='name'
                            placeholder="Enter relation's full name"
                            value={relationDetails.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>
                            Gender <span className="text-red-500">*</span>
                        </label>
                        <select
                            name='gender'
                            id="gender"
                            value={relationDetails.gender}
                            onChange={handleChange}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        >
                            <option value="">Select Gender</option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                        </select>
                    </div>

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>Mobile <span className="text-red-500">*</span></label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            id="mobile"
                            name='mobile'
                            placeholder="Enter relation's Mobile Number"
                            value={relationDetails.mobile}
                            onChange={handleChange}
                            required
                        />
                        <p className="m-0 text-red-500 text-xs">If your relation has no mobile number, enter yours.</p>
                    </div>

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 ${isDarkMode ? "text-gray-100" : " text-gray-700"}`}>Email</label>
                        <input
                            type="email"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            id="email"
                            name='email'
                            placeholder="Enter relation's E-mail address"
                            value={relationDetails.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </>
            )}


        </div>

    );
};

export default Relation;